import { styled } from 'linaria/lib/react';
import { FONTS, COLORS } from '../../../styles/constants';

export const StyledBackground = styled.div<{ backgroundImage?: string }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 528px;
  width: 100%;
  z-index: 1;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: ${({ backgroundImage }) => (backgroundImage ? `url(${backgroundImage})` : 'none')};
    background-size: cover;
    background-position: center;
    filter: blur(25px);
    transform: scale(1.1);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, #92887e, #5e5851);
    opacity: ${({ backgroundImage }) => (backgroundImage ? 0.6 : 1)};
  }
`;

export const StyledContent = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  max-width: 528px;
  overflow: hidden;
  width: 100%;
`;

export const StyledViewControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 66px 12px 0;
  height: 110px;
`;

export const StyledBackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 22px;

  svg {
    width: 24px;
    height: 24px;
  }

  path {
    stroke: ${COLORS.white[100]};
  }
`;

export const StyledMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 16px;
  padding: 0 24px;
`;

export const StyledTitle = styled.h2`
  color: ${COLORS.white[100]};
  font: 400 40px/1.2 ${FONTS.primary};
  margin: 0;
  text-align: center;
`;

export const StyledDomainName = styled.span`
  color: ${COLORS.white[100]};
  font: 400 12px/1.4 ${FONTS.secondary};
`;

export const StyledActionSheet = styled.div`
  margin: 0 24px 34px;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.07);
  background: linear-gradient(270deg, rgba(13, 127, 175, 0.25) 0%, rgba(190, 123, 74, 0.25) 100%),
    linear-gradient(90deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.95) 100%);
`;

export const StyledActionItem = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 16px;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }

  &:active {
    background: rgba(0, 0, 0, 0.06);
  }
`;

export const StyledAvatarCircle = styled.div`
  border-radius: 999px;
  flex-shrink: 0;
  height: 52px;
  overflow: hidden;
  width: 52px;
`;

export const StyledActionIcon = styled.div`
  border: 1px solid rgba(122, 115, 89, 0.6);
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 52px;
  width: 52px;

  svg {
    height: 24px;
    width: 24px;
  }
`;

export const StyledActionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const StyledActionTitle = styled.div`
  color: ${COLORS.brown.dark[100]};
  font: 550 18px/1.3 ${FONTS.secondary};
`;

export const StyledActionSubtitle = styled.div`
  color: ${COLORS.brown.dark[100]};
  font: 400 14px/1.4 ${FONTS.secondary};
`;

export const StyledDivider = styled.div`
  background: rgba(255, 255, 255, 0.3);
  height: 1px;
  width: 100%;
`;

export const StyledSavedTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 16px;
`;

export const StyledSavedTitleText = styled.h2`
  color: ${COLORS.white[100]};
  font: 400 40px/1.2 ${FONTS.primary};
  margin: 0;
  text-align: center;
`;

export const StyledSaveIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;

  path {
    fill: ${COLORS.white[100]};
    stroke: ${COLORS.white[100]};
  }
`;

export const StyledSubTitle = styled.span`
  color: ${COLORS.white[100]};
  font: 400 12px/1.4 ${FONTS.secondary};
  padding-top: 16px;
`;
